import ConsoleSidebar from '@/features/superadmin/components/ConsoleSidebar';

/**
 * Layout de la console de plateforme.
 *
 * Séparé du layout métier : ce ne sont pas les mêmes écrans, pas le même menu,
 * et surtout pas les mêmes droits. Mélanger les deux revenait à donner au super
 * admin une barre de navigation vers des pages qui lui répondent 403.
 */
export default function SuperAdminLayout({ children }) {
  return (
    <div className="flex h-screen overflow-hidden">
      <ConsoleSidebar />
      <main className="flex-1 overflow-auto bg-[#FAFAFA]">{children}</main>
    </div>
  );
}
